import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// export interface compucsan {
//   object: object
// }

@Injectable({
  providedIn: 'root'
})
export class NodejsApiService {

  constructor(
    private http: HttpClient
  ) {}

  getCreditRating(): Observable<any[]> {
    return this.http.get<any[]>('http://beta.staturestyle.com:8081')
  }
}
